// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.js-price-toggle').forEach((toggle) => {
//     toggle.addEventListener('click', function () {
//       const group = this.closest('.price-menu__group');
//       document.querySelectorAll('.price-menu__group').forEach((item) => {
//         if (item !== group) item.classList.remove('is-open');
//       });
//       group.classList.toggle('is-open');
//     });
//   });
// });

document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.js-price-toggle');
  if (!toggle) return;

  const group = toggle.closest('.price-menu__group');
  if (!group) return;

  document.querySelectorAll('.price-menu__group.is-open').forEach((item) => {
    if (item !== group) {
      item.classList.remove('is-open');
    }
  });

  group.classList.toggle('is-open');
});

async function addingSizingKitToCart() {
  const cart = await fetch('/cart.js').then(res => res.json());

  const alreadyAdded = cart.items.some(item => item.id === 56894910923135);

  if (alreadyAdded) return;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: 56894910923135,
      quantity: 1,
      properties: {
        "_product": "Size Kit"
      }
    })
  });
}


async function addingSizingKit(){
  const selected = document.querySelector('input[name="Sizing Kit"]:checked');
  const result = selected ? selected.value : null;

  if( result == "No"){
    return ;
  }

  await addingSizingKitToCart();
}

document.addEventListener("change", function (event) {
  const radio = event.target;

  if ( radio.matches('.sizing-kit-option input[type="radio"][name="Sizing Kit"]')) {
    document.querySelector(".js-product-form.disabled").classList.remove("disabled");
  }
});


function isOnlySizeKitInCart(cart) {
  if (!cart || !Array.isArray(cart.items) || cart.items.length !== 1) {
    return false;
  }

  const item = cart.items[0];

  return (
    item.properties &&
    item.properties._product === "Size Kit"
  );
}



async function removeSizingKit(){
  const cart = await fetch('/cart.json').then(res => res.json());
  const result = isOnlySizeKitInCart(cart);

  if( result ){
    document.querySelector(".js-remove-item").click();
  }
}
